import { render, staticRenderFns } from "./ServiceInformation.vue?vue&type=template&id=320e579f&scoped=true&"
import script from "./ServiceInformation.vue?vue&type=script&lang=js&"
export * from "./ServiceInformation.vue?vue&type=script&lang=js&"
import style0 from "./ServiceInformation.vue?vue&type=style&index=0&id=320e579f&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "320e579f",
  null
  
)

export default component.exports